// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"W_bv","reviews__wrapper__list":"W_dV","reviewSlider":"W_dW"};